import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout as DashboardLayout } from 'src/layouts/setting';
import { PublicLayout } from 'src/layouts/setting/public-layout';
import OrderSummery from 'src/pages/inv/products/orderSummery';
import PaymentResponse from 'src/pages/inv/products/PaymentResponse';


const ProductListPage = lazy(() => import('src/pages/inv/products/productList'));
const ProductCreatePage = lazy(() => import('src/pages/inv/products/createProducts'));
const MyCartsPage = lazy(() => import('src/pages/inv/products/myCarts'));

export const invRoutes = [
  {
    path: 'inv',
    element: (
      <DashboardLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [
      {
        path: 'product',
        children: [
          {
            path: 'myCarts',
            element: <MyCartsPage />
          },
          {
            path: 'orderSummery',
            element: <OrderSummery />
          },
          {
            path: 'PaymentResponse',
            element: <PaymentResponse />
          }
        ]
      },

    ]
  },
  {
    path: '/inv/product',
    element: (
      <PublicLayout>
        <Suspense>
          <ProductListPage />
        </Suspense>
      </PublicLayout>
    )
  },
  {
    path: '/inv/product/createProduct',
    element: (
      <PublicLayout>
        <Suspense>
          <ProductCreatePage />
        </Suspense>
      </PublicLayout>
    )
  },
  // // 🔥 PUBLIC ROUTE (NO LOGIN REQUIRED)
  // {
  //   path: '/inv/product/PaymentResponse',
  //   element: (
  //     <PublicLayout>
  //       <Suspense>
  //         <PaymentResponse />
  //       </Suspense>
  //     </PublicLayout>
  //   )
  // }
];
